import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import LoadingSpinner from "../../../components/Loader/LoadingSpinner";
import { useNavigate } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import API_UTIL from "../../../services/AuthIntereptor";
import Footer from "../../../components/Footer/Footer";
import "../../../components/Footer/Footer.css"; // Import your CSS file
import MergeDuplicateUsers from "./MergeHandler/MergeDuplicateUsers";
import "./Pro.css";
import AppBar from "../../../components/AppBar/AppBar";
import { Icons, Button } from "../../../components/ui";

function Pro() {
  const { eventName } = useParams();
  const [userThumbnails, setUserThumbnails] = useState([]);
  const [clientDetails, setClientDetails] = useState([]);
  const [userDetails, setUserDetails] = useState([]);
  const username =localStorage.getItem("username");
  const [isLoading, setIsLoading] = useState(true);
  const [fetchTimeout, setFetchTimeout] = useState(false);
  const isDataFetched = useRef(false);
  const history = useNavigate();
  const [clickedImg, setClickedImg] = useState(null);
  const [showMergeDuplicateUsers, setShowMergeDuplicateUsers] = useState(false);
  const [mergeMode, setMergeMode] = useState(false);
  const [selectedMainUser, setSelectedMainUser] = useState(null);
  const [selectedDuplicateUsers, setSelectedDuplicateUsers] = useState([]);
  const [showRewardPointsPopUp, setShowRewardPointsPopUp] = useState(null);
  const [rewardPoints,setRewardPoints] = useState();
  const serverIp = process.env.REACT_APP_SERVER_IP;

  const handleClick = (item) => {
    if (mergeMode) {
      handleThumbnailClick(item);
    } else {

    saveShareDetails(item);
      shareOnWhatsApp(item);
      setClickedImg(true);
    }

  };

  const handleClosePopup = () => {
    setShowRewardPointsPopUp(false)
  };

  const handleMergeClick = () => {
    setShowMergeDuplicateUsers(true);
    setMergeMode(true);
    setSelectedMainUser(null);
    setSelectedDuplicateUsers([]);
  };

  const handleCloseMerge = () => {
    setShowMergeDuplicateUsers(false);
    setMergeMode(false);
    setSelectedMainUser(null);
    setSelectedDuplicateUsers([]);
  };

  const handleMerge = async (mainUser, duplicateUsers) => {
    try {
      console.log("Merging", mainUser, "with", duplicateUsers);

      updateRewardPoints(50);
      await fetchThumbnails();
      handleCloseMerge();

    } catch (error) {
      console.error("Error merging users:", error);
    }
  };


  const handleThumbnailClick = (item) => {
    if (!selectedMainUser) {
      setSelectedMainUser(item);
    } else if (selectedDuplicateUsers.length < 5 && !selectedDuplicateUsers.includes(item) && item !== selectedMainUser) {
      setSelectedDuplicateUsers([...selectedDuplicateUsers, item]);
    }
  };


  const shareOnWhatsApp = (item) => {
    const userId = item.user_id;
    const count = item.count;
    const text = `*Greetings*,\nWe have discovered your *${count}* images captured during the event *"${eventName}"*.\nKindly proceed to the provided URL to access and view your photographs:\n${serverIp}/share/${eventName}/${userId}\n\nCheers,\n*Flashback*`;
    const whatsappUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(text)}`;
    window.open(whatsappUrl, "_blank");
  };

  const saveShareDetails = async (item) => {

    try{
      const user =localStorage.userPhoneNumber;


      const response = await API_UTIL.post(`/saveProShareDetails`,{user:user,sharedUser:item.user_id,eventName:eventName});
      if (response.status === 200) {

        updateRewardPoints(10);
      } else {
        throw new Error("Failed to save share info");
      }

    }catch(error){
      console.error("Error fetching user thumbnails:", error);
    }

  };

  const fetchThumbnails = async () => {
    if (userThumbnails.length === 0) setIsLoading(true);

    try {
      const response = await API_UTIL.get(`/userThumbnails/${eventName}`);
      if (response.status === 200) {
        setUserThumbnails(response.data);
        fetchClientDetails();
      } else {
        throw new Error("Failed to fetch user thumbnails");
      }
    } catch (error) {
      console.error("Error fetching user thumbnails:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchClientDetails = async () => {
    if (userThumbnails.length === 0) setIsLoading(true);

    try {
      const response = await API_UTIL.get(`/getClientDetailsByEventname/${eventName}`);
      if (response.status === 200) {
        setClientDetails(response.data);
        console.log(response.data.user_name)
        fetchuserDetails();
      } else {
        throw new Error("Failed to fetch client Details");
      }
    } catch (error) {
      console.error("Error fetching user thumbnails:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchuserDetails = async () => {
    if (userThumbnails.length === 0) setIsLoading(true);

    try {
      const response = await API_UTIL.get(`/getUserDetails/${localStorage.getItem('userphoneNumber')}`);
      if (response.status === 200) {
        setUserDetails(response.data);
      } else {
        throw new Error("Failed to fetch client Details");
      }
    } catch (error) {
      console.error("Error fetching user thumbnails:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const updateRewardPoints = async (points) =>{
    const updateData = {
      user_phone_number:localStorage.userPhoneNumber,
      reward_points : userDetails?.reward_points ? userDetails.reward_points + points : 50 + points
    };

    try {
      const response = await API_UTIL.post('/updateUserDetails', updateData);
      if (response.status === 200) {
        setRewardPoints(points)
        setShowRewardPointsPopUp(true);
        setUserDetails(response.data.data)
      } else {
        console.log("Failed to update user details. Please try again.");
      }
    } catch (error) {
      console.error("Error updating user details:", error);
    }

  }

  useEffect(() => {
    if (isDataFetched.current) return;
    fetchThumbnails();

    isDataFetched.current = true;
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          <AppBar/>
          <div className="fade-in flex-1 max-w-[1400px] w-full mx-auto px-4 sm:px-6 py-6">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-6">
              <div className="flex items-center gap-3">
                <Button variant="secondary" icon={Icons.Users} onClick={handleMergeClick}>
                  Merge Duplicate Faces
                </Button>
              </div>
              <div className="bg-white border border-gray-200 rounded-xl px-4 py-2.5 shadow-card">
                <span className="text-xs font-semibold uppercase tracking-wider text-slate-500">
                  Total Attendees
                </span>
                <span className="ml-2 text-lg font-bold text-slate-900">{userThumbnails.length}</span>
              </div>
            </div>

            {showMergeDuplicateUsers && (
              <MergeDuplicateUsers
                onClose={handleCloseMerge}
                onMerge={handleMerge}
                thumbnails={userThumbnails}
                selectedMainUser={selectedMainUser}
                selectedDuplicateUsers={selectedDuplicateUsers}
                onMainUserSelect={setSelectedMainUser}
                onDuplicateUserSelect={setSelectedDuplicateUsers}
              />
            )}

            {userThumbnails.length > 0 ? (
              <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-8 gap-3">
                {userThumbnails.map((item, index) => {
                  const isMain = mergeMode && selectedMainUser === item;
                  const isDup = mergeMode && selectedDuplicateUsers.includes(item);
                  return (
                    <div
                      key={index}
                      className={`relative aspect-square rounded-lg overflow-hidden border bg-gray-50 cursor-pointer transition group ${
                        isMain
                          ? "border-brand-600 ring-2 ring-brand-500/40"
                          : isDup
                          ? "border-rose-400 ring-2 ring-rose-400/40"
                          : "border-gray-200 hover:border-brand-200"
                      }`}
                      onClick={() => handleClick(item)}
                    >
                      <LazyLoadImage
                        src={item.face_url}
                        alt={`User ${index + 1}`}
                        className="w-full h-full object-cover"
                      />
                      <span className="absolute bottom-0 left-0 right-0 bg-slate-900/80 text-white text-[11px] font-semibold text-center py-1">
                        {item.count}
                      </span>
                    </div>
                  );
                })}
              </div>
            ) : fetchTimeout ? (
              <p className="text-slate-500 text-sm">No images to display</p>
            ) : (
              <p className="text-slate-500 text-sm">Failed to load images</p>
            )}
          </div>

          <Footer />
        </>
      )}
    </div>
  );
}

export default Pro;
